import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../widgets/form/InputTextSF'

const UserPhoneNumberUpdateModalUI = ({ context, successMsg, errorList, setErrorList,
  // modes
  updateMode, submitted,
  // event handlers
  onSubmit, onCancelClick,
  //
  phoneNumber, onPhoneNumberChange, phoneNumberError, setPhoneNumberError,

}) =>
  <ModalFormUI
    context={context}
    titleLabel='Update Phone Number'
    buttonLabel='Update'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >

    <InputTextSF type='text' name='phoneNumber' label='Phone Number'
      value={phoneNumber} onChange={onPhoneNumberChange}
      error={phoneNumberError} setError={setPhoneNumberError}
      placeholder='Enter 10 digit phone number'
      maxLength={10}
      required={true}
    />

  </ModalFormUI>

export default UserPhoneNumberUpdateModalUI
